/*
 * Utilitaires des statistiques du tunnel : ordre des etapes et taux de
 * passage. Les exports CSV et PDF sont generes cote serveur (lib/api).
 */

/* Ordre du tunnel : de la premiere visite jusqu'au rendez vous confirme. */
export const FUNNEL_STEPS = [
  { key: "page_viewed", label: "Page consultée" },
  { key: "diagnostic_started", label: "Diagnostic commencé" },
  { key: "progress_25", label: "Progression 25 %" },
  { key: "progress_50", label: "Progression 50 %" },
  { key: "progress_75", label: "Progression 75 %" },
  { key: "diagnostic_completed", label: "Diagnostic terminé" },
  { key: "synthesis_viewed", label: "Bilan consulté" },
  { key: "pdf_downloaded", label: "PDF téléchargé" },
  { key: "email_requested", label: "Envoi email demandé" },
  { key: "email_sent", label: "Email envoyé" },
  { key: "fit_started", label: "Questionnaire FIT commencé" },
  { key: "fit_completed", label: "Questionnaire FIT terminé" },
  { key: "lead_nurture", label: "Orientation conseils" },
  { key: "relance_sent", label: "Email de rappel envoyé" },
  { key: "calendar_viewed", label: "Calendrier consulté" },
  { key: "appointment_booked", label: "Rendez vous réservé" },
  { key: "appointment_confirmed", label: "Rendez vous confirmé" },
];

/*
 * Taux de passage : pourcentage entre chaque étape et la précédente.
 * L'étape relance_sent est exclue de la chaîne (plusieurs rappels possibles
 * par personne : un pourcentage serait trompeur).
 */
export const computeConversions = (events) => {
  const result = {};
  let previous = null;
  FUNNEL_STEPS.forEach((step) => {
    if (step.key === "relance_sent" || step.key === "lead_nurture") {
      result[step.key] = null;
      return;
    }
    const count = events[step.key] || 0;
    result[step.key] = previous !== null && previous > 0 ? Math.round((count / previous) * 100) : null;
    previous = count;
  });
  return result;
};
